/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { Button, Icon } from 'semantic-ui-react'
import React from 'react'
import { useTranslation } from 'react-i18next'

const ItemsAwaitingActionButton = ({ orderItemListRef, orderItems }) => {
    const [t] = useTranslation()

    return (
      <Button
        icon
        fluid
        color="yellow"
        css={css`
            &.ui.button {
                display: flex;
                justify-content: space-between;
            }
        `}
        onClick={() => {
            const orderItem = orderItems.find(item => item.customerAckType === 'AWAITING_ACTION')
            if (!orderItemListRef.current || !orderItem) {
                return
            }

            if (typeof orderItemListRef.current.scrollToItem === 'function') {
                orderItemListRef.current.scrollToItem(orderItem.id)
            }
        }}
      >
          <Icon name="arrow down"/>
            {t('order.detail.items_awaiting_customer_action')}
          <Icon name="arrow down"/>
      </Button>
    )
}

export { ItemsAwaitingActionButton }
